import '../../sass/layout/sections/section-maps.scss';
import Swiper from 'swiper';
import {Pagination, Navigation,  Autoplay,  EffectFade} from 'swiper/modules';

const swiperMaps = document.getElementById('swiperMaps');

if(swiperMaps) {
    const pagination = swiperMaps.querySelector('.swiper-pagination');
    const prevEl = swiperMaps.querySelector('.swiper-button-prev');
    const nextEl = swiperMaps.querySelector('.swiper-button-next');
    const swiper = new Swiper(swiperMaps, {
        modules: [Pagination, Navigation, Autoplay, EffectFade],
        loop: false,
        speed: 500,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: pagination,
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="${className}" style="top: calc(${paginationPosition[index][0]} - 6px); left: calc(${paginationPosition[index][1]} - 6px)"></span>`;
            },
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
        init: false,
    })  
    swiper.on('init', function () {
        const paginationAll = swiperMaps.querySelectorAll('.swiper-pagination-bullet');
        let pSize = [6, 6];
        let pSizeA = [8, 10];
        if(window.innerWidth >= 1366 && window.innerWidth < 1919.99){
            pSize = [4, 4];
            pSizeA = [6, 6];
        }
        paginationAll.forEach((el, index) => {
            if(el.classList.contains('swiper-pagination-bullet-active')) {
                el.style.top = `calc(${paginationPosition[index][0]} - ${pSizeA[0]}px`;
                el.style.left = `calc(${paginationPosition[index][1]} - ${pSizeA[1]}px`;
            } else {
                el.style.top = `calc(${paginationPosition[index][0]} - ${pSize[0]}px`;
                el.style.left = `calc(${paginationPosition[index][1]} - ${pSize[1]}px`;
            }
        })
    });
    swiper.on('slideChange', function () {
        const paginationAll = swiperMaps.querySelectorAll('.swiper-pagination-bullet');
        let pSize = [6, 6];
        let pSizeA = [8, 10];
        if(window.innerWidth >= 1366 && window.innerWidth < 1919.99){
            pSize = [4, 4];
            pSizeA = [6, 6];
        }
        paginationAll.forEach((el, index) => {
            if(el.classList.contains('swiper-pagination-bullet-active')) {
                el.style.top = `calc(${paginationPosition[index][0]} - ${pSizeA[0]}px`;
                el.style.left = `calc(${paginationPosition[index][1]} - ${pSizeA[1]}px`;
            } else {
                el.style.top = `calc(${paginationPosition[index][0]} - ${pSize[0]}px`;
                el.style.left = `calc(${paginationPosition[index][1]} - ${pSize[1]}px`;
            }
        })
    });
    swiper.init();


}